import { render, staticRenderFns } from "./redetermine-subject.vue?vue&type=template&id=c3fa25f6&scoped=true"
import script from "./redetermine-subject.vue?vue&type=script&lang=js"
export * from "./redetermine-subject.vue?vue&type=script&lang=js"
import style0 from "./redetermine-subject.vue?vue&type=style&index=0&id=c3fa25f6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3fa25f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3fa25f6')) {
      api.createRecord('c3fa25f6', component.options)
    } else {
      api.reload('c3fa25f6', component.options)
    }
    module.hot.accept("./redetermine-subject.vue?vue&type=template&id=c3fa25f6&scoped=true", function () {
      api.rerender('c3fa25f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/research/redetermine-subject.vue"
export default component.exports